import React from "react";
import { Layout } from "antd";
import "antd/dist/reset.css";
import "./customLayout.css";
import AppRouter from "./Routes";
import { MenuView } from "../menu/home/MenuView";
import { HeaderView } from "../menu/home/HeaderView";

const { Header, Content, } = Layout;

export const AnonymousLayout = () => {
  return (
    <div>
      <Layout className="site-layout">
        <Header>
          <HeaderView />
        </Header>

        <MenuView />
        <Content>
          <div>
            <AppRouter />
          </div>
        </Content>
        {/* <Footer style={{ textAlign: "center" }}>
          <FooterView />
        </Footer> */}
      </Layout>
    </div>
  );
};
